import { ReactNode } from 'react';

import { TrialLoadingSpinner } from './_components/TrialLoadingSpinner';
import { useTrial } from './TrialProvider';

type Props = {
  page: ReactNode;
  paywall: ReactNode;
};

export const UnblockPremiumFeaturePage = ({ page, paywall }: Props) => {
  const { isLoading, isEligible } = useTrial();

  if (isLoading) {
    return <TrialLoadingSpinner />;
  }

  if (isEligible) {
    return paywall;
  }

  return page;
};
